import { render, staticRenderFns } from "./PostulationsManagementPlus.vue?vue&type=template&id=a6e182ec&scoped=true&"
import script from "./PostulationsManagementPlus.vue?vue&type=script&lang=js&"
export * from "./PostulationsManagementPlus.vue?vue&type=script&lang=js&"
import style0 from "./PostulationsManagementPlus.vue?vue&type=style&index=0&id=a6e182ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e182ec",
  null
  
)

export default component.exports